import { useTranslation } from 'react-i18next'

import { supportedLanguages } from '../i18n'

export function LanguageControl() {
  const { t, i18n } = useTranslation()

  return (
    <label className='language-control'>
      <span className='sr-only'>{t('Language')}</span>
      <select
        aria-label={t('Language')}
        value={i18n.resolvedLanguage ?? i18n.language}
        onChange={(event) => void i18n.changeLanguage(event.target.value)}
      >
        {supportedLanguages.map((language) => (
          <option key={language} value={language}>
            {t(`language.${language}`)}
          </option>
        ))}
      </select>
    </label>
  )
}
